import { Component, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { AuthService } from '@fuse/services/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'mail-confirm',
    templateUrl: './mail-confirm.component.html',
    styleUrls: ['./mail-confirm.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class MailConfirmComponent implements OnInit, OnDestroy {

    private _unsubscribeAll: Subject<any>;

    processedEmail = '';
    title = '';
    lang = 'sr';
    registeredWithSocial = '';

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _authService: AuthService,
        private _translate: TranslateService,
        private _translationLoader: FuseTranslationLoaderService
    ) {
        // Configure the layout
        this._fuseConfigService.config = {
            theme: {
                layout: {
                    navbar: {
                        hidden: true
                    },
                    toolbar: {
                        hidden: true
                    },
                    footer: {
                        hidden: true
                    },
                    sidepanel: {
                        hidden: true
                    }
                }
            }
        };

        this._unsubscribeAll = new Subject();

    }

    private getTranslations(): void {
        this._translationLoader.getLastLang()
            .then(response => {
                this.lang = response['code'];
                this._translationLoader.getTranslations(this.lang, '5');
            })
            .catch(err => Promise.reject(err))
            .then(() => {
            }, err => {
            });
    }

    private titleCase(str): string {
        return str.replace(/\w\S*/g, (txt: any) => (txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()));
    }

    ngOnInit(): void {
        this.processedEmail = this._authService.processedEmail.email;

        if (this._authService.processedEmail.action === 'register') {
            this.title = this._translate.instant('Registration successfully completed!');
        } else {
            this.title = this._translate.instant('Password reset successful!');
        }

        this.registeredWithSocial = this.titleCase(this._authService.registeredWithSocial);

        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(value => {
                this.getTranslations();
            });
        this.getTranslations();

    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
